var map = {
	"./de_DE.json": 1951,
	"./en_AU.json": 1952,
	"./en_CA.json": 1953,
	"./en_GB.json": 1954,
	"./es_AR.json": 1955,
	"./es_ES.json": 1956,
	"./es_MX.json": 1957,
	"./fr_CA.json": 1958,
	"./fr_FR.json": 1959,
	"./it_IT.json": 1960,
	"./nl_NL.json": 1961,
	"./pt_BR.json": 1962,
	"./pt_PT.json": 1963
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1950;


//////////////////
// WEBPACK FOOTER
// ./src/translations/locale \.json$
// module id = 1950
// module chunks = 0